import Vue from "vue";
import Vuex from "vuex";
import router from "./router/index.js";

Vue.use(Vuex);

const state = {
  consoleLog:{
    bold : "background: #222; color: #fff",
    error : "background: red; color: #fff",
    message : "background: #eee; color: #333",
  },
  sidebarShow: "responsive",
  sidebarMinimize: false,
  base: null,
  token: "",
  loding: false,
  formLoading: false,
  formerror: false,
  status: null,
  data: {
    notification: [],
  },
  isAdmin: true,
  alert: {
    error_msg: {
      statusText: null,
      status: null,
      data: [],
    },
    successMessage: null,
    successcount:0,
    errorcount:0,
  },
  webhook: "danger",
  socket:{
    contactImporter:{
      content:'',
      done:false
    },
    call_export:{
      status:"",
    }
  },
  toasts: []
};
const getters = {
  checksessions: (state) => {
    return state.status;
  },
  currentUser: (state) => {
    return state.data.id;
  },
  toasts: (state) => {
    return state.toasts;
  },
  socketMessage: (state) => {
    return state.socketMessage;
  },
  token: (state) => {
    return state.token;
  },
  consoleLog: (state) => {
    return state.consoleLog;
  },
  ContactImportIsDone: (state) => {
    return state.socket.contactImporter.done;
  },
};
const mutations = {
  addToast (state, array) {
    state.toasts.push(array);
  },
  contactImporterContent (state, n) {
    state.socket.contactImporter.content = n;
  },
  contactImporterContentIsDone (state, n) {
    state.socket.contactImporter.done = n;
  },
  callExportStatus (state, n) {
    state.socket.call_export.status = n;
  },
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarOpened ? false : "responsive";
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
    state.sidebarShow = sidebarClosed ? true : "responsive";
  },
  set(state, [variable, value]) {
    state[variable] = value;
  },
  remove_notification(state, row_id) {
    // state.data.notification = state.data.notification.filter(function(item,row_id){ return item.id != row_id })
    const array = state.data.notification;
    for (let [index, value] of array.entries()) {
      if (value.id == row_id) {
        state.data.notification.splice(index, 1);
      }
    }
    // state.data.notification.splice(index, 1);
  },
  remove_all_notification() {
    state.data.notification = [];
    var token = localStorage.getItem("token");
    if (token) axios.defaults.headers.common.Authorization = "Bearer " + token;
    axios.get("https://api.hamkaran.cloud/api/v1/notification/read?id=all");
  },
  updateStatus(state, data) {
    state.status = data;
  },
};

const actions = {
  login({ commit, state }, data) {
    state.formLoading = true;
    state.formerror = false;
    var config = {
      method: "post",
      url: "https://api.hamkaran.cloud/v1/login",
      data: data,
    };

    axios.defaults.headers.common.Authorization = "";
    axios(config)
      .then(function(response) {
        if (response.data.token) {
          console.log("inja");
          state.status = true;
          state.token = response.data.token;
          console.log(state.token);
          localStorage.setItem("token", state.token);
          router.push({ path: "/" }).catch((err) => {});
        } else {
          state.status = false;
          state.formLoading = false;
          state.formerror = true;
          state.token = "";
        }
      })
      .catch(function(error) {
        state.formLoading = false;
        state.formerror = true;
        // console.log(error);
      });
  },
  async checksessions({ commit, state }) {
    state.token = localStorage.getItem("token");
    if (state.token)
      axios.defaults.headers.common.Authorization = "Bearer " + state.token;
    await axios
      .get("https://api.hamkaran.cloud/api/v1/checksessions")
      .then((res) => {
        console.log(res.data);
        if (res.data == false) {
          state.status = false;
        } else {
          state.status = true;
          state.data = res.data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  async logout({ commit, state }) {
    state.token = localStorage.getItem("token");
    if (state.token)
      axios.defaults.headers.common.Authorization = "Bearer " + state.token;

    await axios
      .get("https://api.hamkaran.cloud/api/v1/logout")
      .then((res) => {
        state.status = false;
        state.formLoading = false;
        router.push({ path: "/login" }).catch((err) => {});
      })
      .catch((err) => {
        console.log(err);
      });
  },
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});
